export default __webpack_public_path__ + "static/media/googledrive-icon.80bb7613.png";